import React from 'react';
import PropTypes from 'prop-types';
import { FDIcon, FDLabelText, FDStack } from '@facet-wealth/design';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { getThresholdColorMap } from 'Consts/thresholds';
import useMobileLayout from 'Hooks/useMobileLayout';
import { dataAttrs } from 'Helpers/Testing';

const useStyles = buildUseStyles('GuidedHouseholdReviewZoneDescriptions', (theme) => ({
  ...(Object.fromEntries(Object.entries(getThresholdColorMap(theme)).map(([colorName, color]) => ([
    `color${colorName}`,
    {
      '& .FD-MuiSvgIcon-root': {
        color: `${color} !important`,
      },
    },
  ])))),
}));

export const GuidedHouseholdReviewZoneDescriptions = ({ resource }) => {
  const classes = useStyles();
  const isMobile = useMobileLayout();
  const zoneDescriptions = resource.attr('zoneDescriptions')?.resources()?.list() ?? [];
  if (zoneDescriptions.length === 0) {
    return null;
  }
  return (
    <FDStack direction="row" alignItems="center" justifyContent="center" spacing={isMobile ? 1 : 3} wrap={isMobile}>
      {zoneDescriptions.map((zoneDescription) => (
        <FDStack spacing={1} alignItems="center" {...dataAttrs('zone-description')}>
          <div className={classes[`color${zoneDescription.attr('color')}`]}>
            <FDIcon icon={zoneDescription.attr('icon')} />
          </div>
          <FDLabelText value={zoneDescription.attr('name')} />
        </FDStack>
      ))}
    </FDStack>
  );
};

GuidedHouseholdReviewZoneDescriptions.propTypes = {
  resource: PropTypes.object.isRequired,
};
